import { createCancelAccountToken } from '../services/accountService'

function fetchCancelAccountTokenCreate() {
  return () => createCancelAccountToken()
}

export default fetchCancelAccountTokenCreate



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchCancelAccountTokenCreate.js